import '../CsvJsonInfoPages.scss';


function ColourAndTrimLinksNVDE() {

    const data = [
        { field: 1, description: 'Period Code (Int)' },
        { field: 2, description: 'Colour Code (Int)' },
        { field: 3, description: 'Trim Code (Int)' },
    ];

    const data2 = [
        { field: 1, description: 'Period Code (Int)' },
        { field: 2, description: 'CAP ID (Int)' },
        { field: 3, description: 'Date Effective From (Date)' },
        { field: 4, description: 'Date Effective To (Date)' },
    ];



    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Colour & Trim Links</h1>
            <p>This file provides links between vehicle colours and the trims available for them. <br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDColourTrimLinks.txt .txt<br />
                LIGHTS_yyyy-mm-dd_NVDColourTrimLinks.txt .txt<br />
                HEAVIES_yyyy-mm-dd_NVDColourTrimLinks.txt .txt<br />
                BIKES_yyyy-mm-dd_NVDColourTrimLinks.txt .txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <p>
                <b>Colour Trim/Hood Links Periods</b><br /><br />
                This file provides a list of periods denoting when colour/trim or hood links are valid from/to.<br /><br />

                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDCTHPeriods.txt .txt<br />
                LIGHTS_yyyy-mm-dd_NVDCTHPeriods.txt .txt<br />
                HEAVIES_yyyy-mm-dd_NVDCTHPeriods.txt .txt<br />
                BIKES_yyyy-mm-dd_NVDCTHPeriods.txt .txt<br /><br />

                Note: yyyymmdd represents the date of the product. E.g. 20030701 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data2.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default ColourAndTrimLinksNVDE;
